export const fileStatus = {
    pending: 'pending',
    pointed: 'pointed'
};
